// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__GtyDEXdI","removeIcon":"removableTag_removeIcon__R2yd4MKW"};